export type ContactMessage = { body: string; context?: MessageContext; subject?: string };

export enum MessageContext {
  BATTERY_ADDON = 'Battery Add-on',
  CUSTOMER_COMMS = 'Customer Comms',
  ORDER_HOLD = 'Order Hold',
}
